__turbopack_context__.v({
  "container": "VerifiedContractsPage-module__yPhqLG__container",
  "contractAddress": "VerifiedContractsPage-module__yPhqLG__contractAddress",
  "contractIcon": "VerifiedContractsPage-module__yPhqLG__contractIcon",
  "contractInfo": "VerifiedContractsPage-module__yPhqLG__contractInfo",
  "contractName": "VerifiedContractsPage-module__yPhqLG__contractName",
  "emptyState": "VerifiedContractsPage-module__yPhqLG__emptyState",
  "filterButton": "VerifiedContractsPage-module__yPhqLG__filterButton",
  "header": "VerifiedContractsPage-module__yPhqLG__header",
  "license": "VerifiedContractsPage-module__yPhqLG__license",
  "pageButton": "VerifiedContractsPage-module__yPhqLG__pageButton",
  "pageButtonActive": "VerifiedContractsPage-module__yPhqLG__pageButtonActive",
  "pagination": "VerifiedContractsPage-module__yPhqLG__pagination",
  "searchContainer": "VerifiedContractsPage-module__yPhqLG__searchContainer",
  "searchIcon": "VerifiedContractsPage-module__yPhqLG__searchIcon",
  "searchInput": "VerifiedContractsPage-module__yPhqLG__searchInput",
  "settingIconGreen": "VerifiedContractsPage-module__yPhqLG__settingIconGreen",
  "settingIconRed": "VerifiedContractsPage-module__yPhqLG__settingIconRed",
  "settingItem": "VerifiedContractsPage-module__yPhqLG__settingItem",
  "settingLabel": "VerifiedContractsPage-module__yPhqLG__settingLabel",
  "settings": "VerifiedContractsPage-module__yPhqLG__settings",
  "shimmer": "VerifiedContractsPage-module__yPhqLG__shimmer",
  "skeleton": "VerifiedContractsPage-module__yPhqLG__skeleton",
  "statCard": "VerifiedContractsPage-module__yPhqLG__statCard",
  "statLabel": "VerifiedContractsPage-module__yPhqLG__statLabel",
  "statValue": "VerifiedContractsPage-module__yPhqLG__statValue",
  "statsGrid": "VerifiedContractsPage-module__yPhqLG__statsGrid",
  "table": "VerifiedContractsPage-module__yPhqLG__table",
  "tableContainer": "VerifiedContractsPage-module__yPhqLG__tableContainer",
  "title": "VerifiedContractsPage-module__yPhqLG__title",
  "verified": "VerifiedContractsPage-module__yPhqLG__verified",
  "verifiedIcon": "VerifiedContractsPage-module__yPhqLG__verifiedIcon",
});
